/**
 * @ngdoc directives
 * @member of mercury.directives
 * @name inputleave
 * @description provides special input for entering leave in the payrun editor
 */
angular.module('mercury.directives.inputleave', [])
.directive('inputleave', function() {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'directives/inputleave/inputleave.tpl.html',
    link: function(scope, elem) {
      scope.popoverOpen = false;

      elem.attr('readonly', 'readonly');

      var setInput = function() {
        var value = scope.leaveType.rate * scope.leaveType.quantity;
        if (value === 0) {
          elem.find('.table-leavebox').val('Add');
        } else {
          elem.find('.table-leavebox').val('$' + value.toFixed(2));
        }
      };

      setInput();

      scope.holidayPayUpdated = function() {
        setInput();
        scope.$parent.updateTotals(scope.$parent.payrunLine);
        scope.popoverOpen = false;
      };
    }
  };
});
